import { Select } from 'twyne-new.ui';

import { useCraftProp } from '@/components/builder/utils';

import { ArbitraryUnit } from './PredefinedArbitraryUnit';

export default function GridSizeProperty({ sizeName, sizeFixedName, options }) {
  const { value: size, setValue: setSize } = useCraftProp(sizeName)
  const { value: sizeFixed, setValue: setSizeFixed } = useCraftProp(sizeFixedName)

  const addUnderscore = value => value && String(value).replace(/(\d)([a-zA-Z%]+)/g, '$1_$2')

  return <>
    <div className='flex items-center justify-between gap-1'>
      {size === 'fixed' && <>
        <ArbitraryUnit
          value={addUnderscore(sizeFixed)}
          onChange={setSizeFixed}
        />
      </>}
      <Select
        options={options}
        value={size}
        onChange={item => setSize(item.value)}
        variant='accent'
        className={size === 'fixed' ? '!w-28' : 'w-full'}
      />
    </div>
  </>
}
